import React from 'react'
import { useDispatch } from 'react-redux'
import { toggleContactForm, setContactFormCustomText } from '../store/appSlice'
import { Button } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

const ButtonContactForm = () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const onContactToggle = () => {
        dispatch(setContactFormCustomText(t('common.learnMore')))
        dispatch(toggleContactForm())
    }
  return (
    <Button
        bg={'pink.100'}
        marginTop={'5vh'}
        marginBottom={'3vh'}
        backdropFilter={'blur(10px)'}
        onClick={onContactToggle}
        >
        {t('common.reserve')}
    </Button>
  )
}

export default ButtonContactForm
